import { PageSectionsContentSectionContentBlocksImageInformationCardList, PageSectionsContentSectionContentBlocksImageInformationCardListInformationCards } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import '../styles/tokens.stylex';
import { spacing } from '../styles/tokens.stylex';
import { InfoCard } from './InfoCard';
interface CardListProps {
  data: PageSectionsContentSectionContentBlocksImageInformationCardList;
}
type ListType = {
  columns: 1 | 2 | 3;
  cardVariant: 'regularWithImage' | 'largeWithImage' | 'regular';
};
const LIST_TYPES = {
  Regular: {
    columns: 2,
    cardVariant: 'regularWithImage'
  },
  Large: {
    columns: 1,
    cardVariant: 'largeWithImage'
  },
  Small: {
    columns: 3,
    cardVariant: 'regularWithImage'
  }
};
export function InfoCardList({
  data,
  ...props
}: CardListProps) {
  const listType = LIST_TYPES[(data.displayType || 'Regular') as keyof typeof LIST_TYPES];
  return data ? <ul {...stylex.props([styles.root, columnVariants[(listType?.columns || 2) as ListType['columns']]])} {...props}>
      {data.informationCards?.map((card, i) => <InfoCard data={card as PageSectionsContentSectionContentBlocksImageInformationCardListInformationCards} key={`${i}-${card?.heading}`} cardVariant={listType?.cardVariant as 'regularWithImage' | 'largeWithImage'} />)}
    </ul> : null;
}
const styles = {
  root: {
    k1xSpc: "xrvj5dj",
    kmVPX3: "x1717udv",
    kogj98: "x1ghz6dp",
    kOIVth: "x1mhrlx8",
    k9llMU: "x1rlqdvi",
    $$css: true
  }
};
const columnVariants = {
  "1": {
    kumcoG: "x1o61qjw",
    $$css: true
  },
  "2": {
    kumcoG: "x1o61qjw x1czzsap",
    $$css: true
  },
  "3": {
    kumcoG: "xt2d6zu xsrf0k6",
    $$css: true
  }
};